/** Inclusive ids between two items in the current list order. */
export function idsBetween(orderedIds, fromId, toId) {
  const ids = Array.isArray(orderedIds) ? orderedIds : [];
  const end = ids.indexOf(toId);
  if (end === -1) return [];
  const start = ids.indexOf(fromId);
  if (start === -1) return [toId];
  const lo = Math.min(start, end);
  const hi = Math.max(start, end);
  return ids.slice(lo, hi + 1);
}

/**
 * Checkbox/list selection: click toggles one row; Shift+click selects the
 * range from the last anchor through the clicked row (inclusive).
 */
export function applyListSelection(prevSelected, { id, orderedIds, shiftKey, anchorId }) {
  const next = new Set(prevSelected);
  if (shiftKey && anchorId != null && id != null) {
    for (const rangeId of idsBetween(orderedIds, anchorId, id)) {
      next.add(rangeId);
    }
    return { selected: next, anchorId };
  }
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return { selected: next, anchorId: id };
}
